import React from 'react';

const MainFloorIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.585 1.29883H20.7803V20.7803H23.3779V23.3779H18.1826V3.89648H15.585V23.3779H0V20.7803H2.59766V0H15.585V1.29883ZM5.19531 20.7803H12.9873V2.59766H5.19531V20.7803ZM11.6885 12.9883H9.09082V10.3906H11.6885V12.9883Z" fill="currentColor" />
    </svg>
  );
};

export default MainFloorIcon;
